import { Component, OnInit } from '@angular/core';
import { CartService } from 'src/app/services/cart.service';
import { AuthenticationService, MIAUser } from '@mobileia/authentication';
import { ActivatedRoute } from '@angular/router';
import { TransactionService } from 'src/app/services/transaction.service';

@Component({
  selector: 'app-step-three',
  templateUrl: './step-three.component.html',
  styleUrls: ['./step-three.component.scss']
})
export class StepThreeComponent implements OnInit {

  currentUser = new MIAUser();
  transactionId = 0;
  userEmail = '';

  constructor(
    protected cartService: CartService,
    protected authService: AuthenticationService,
    protected route: ActivatedRoute,
    protected transactionService: TransactionService
  ) { }

  ngOnInit() {
    this.cartService.clean();
    this.loadTransaction();
    this.loadUser();
    this.userEmail = this.transactionService.email || '';
  }

  loadTransaction() {
    this.route.params.subscribe(params => {
      if (params.id) {
        this.transactionId = params.id;
      }
    });
  }
  
  loadUser() {
    this.authService.currentUser.subscribe(data => {
      if (data == null) {
        return;
      }
      this.currentUser = data;
      // Use auth email if available, otherwise use transaction email
      if (data.email) {
        this.userEmail = data.email;
      }
    });
  }
}
